import { render, staticRenderFns } from "./gongjijin.vue?vue&type=template&id=c1c72012&scoped=true&"
import script from "./gongjijin.vue?vue&type=script&lang=js&"
export * from "./gongjijin.vue?vue&type=script&lang=js&"
import style0 from "./gongjijin.vue?vue&type=style&index=0&id=c1c72012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c72012",
  null
  
)

export default component.exports